import { useContext, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { IntlContext } from '@/i18n';
import { IDocsListItem } from '@src-common/view/components/DocsList';

import { TUploadScope } from '../RelatedInfo/config';

import { collapseDocsList } from './collapse-docs-list';
import { getSupplementaryGroups } from './config';

const useCollapsedDocsList = <TDoc extends IDocsListItem>(
  docs: TDoc[],
  scope: TUploadScope,
): TDoc[] => {
  const intl = useIntl();
  const { region } = useContext(IntlContext);

  return useMemo(
    () => collapseDocsList(docs, getSupplementaryGroups(scope, region), intl),
    [docs, scope, region, intl],
  );
};

export { useCollapsedDocsList };
